"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function OurStory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section className="relative min-h-screen w-full overflow-hidden bg-background">
      <div className="mx-auto grid h-full min-h-screen w-full grid-cols-1 lg:grid-cols-[42fr_58fr]">
        {}
        <div className="relative w-full overflow-hidden bg-background aspect-square lg:aspect-auto">
          <div className="absolute inset-0 h-full w-full bg-contain bg-no-repeat bg-center transition-transform duration-700 ease-out origin-center !bg-[url(https://educationfamilytutors.com/wp-content/uploads/2026/02/53253d5a-0d07-426a-a9c6-abbdd2b3eefd-scaled.png)]" style={{
          transform: isVisible ? "scale(1)" : "scale(1)"
        }} />
        </div>

        {}
        <div className="flex items-center justify-center px-6 py-12 lg:px-12 lg:py-16">
          <div ref={ref} className={`w-full max-w-2xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <Card className="hover-lift bg-light-background shadow-medium">
              <CardHeader>
                <CardTitle className="font-display text-3xl text-primary lg:text-4xl">
                  Our Story - Education Family Tutors
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <p className="text-base leading-relaxed text-foreground lg:text-lg">
                    Education Family Tutors was founded on the belief that every
                    student has the potential to excel when given the right
                    support and guidance. We combine expert academic tutoring with
                    confidence and mindset coaching to help KS3 and GCSE students
                    not only improve their grades but also build the resilience
                    and motivation needed for long-term success.
                  </p>
                  
                  <p className="text-base leading-relaxed text-foreground lg:text-lg">
                    While many tutoring services focus solely on academic content,
                    we recognised that true educational success requires more than
                    just subject knowledge. Founded by <strong>Neb</strong>, an experienced
                    educator with a passion for holistic student development, our
                    approach integrates personal development coaching with rigorous
                    academic instruction.
                  </p>
                  
                  <p className="text-base leading-relaxed text-foreground lg:text-lg">
                    The vision behind Education Family Tutors emerged from years of
                    classroom experience, where we saw firsthand how confidence,
                    focus, and motivation directly impact academic performance. We
                    created our programmes to address both the intellectual and
                    emotional aspects of learning, ensuring students develop the
                    complete skill set needed for exam success and beyond.
                  </p>
                  
                  <p className="text-base leading-relaxed text-foreground lg:text-lg">
                    Our team of qualified UK teachers is dedicated to creating
                    personalised learning experiences that empower students to thrive
                    both in and out of the classroom. Each tutor brings not only
                    subject expertise but also a genuine commitment to nurturing
                    student confidence and independence.
                  </p>
                  
                  <p className="text-base leading-relaxed text-foreground lg:text-lg">
                    Education Family Tutors continues to grow and evolve, but our
                    core mission remains unchanged: to provide comprehensive support
                    that transforms students into confident, capable learners who
                    approach their education with enthusiasm and self-belief. We are
                    proud to partner with families across the UK in this important
                    journey.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}